import React from 'react';
import './src/styles/global.css';
import './src/styles/animations.css';
import CookieConsent from './src/components/consent/CookieConsent';
import { initConsent } from './src/consent/consent';

export const onClientEntry = () => {
  initConsent();
};

// SPA page views (gtag config runs with send_page_view: false). Consent Mode
// decides whether each hit may use cookies; this only reports the route.
export const onRouteUpdate = ({ location }) => {
  if (process.env.NODE_ENV !== 'production' || typeof window.gtag !== 'function') return;
  const send = () => {
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search + location.hash,
      page_location: window.location.href,
      page_title: document.title,
    });
  };
  // let react-helmet update the title first
  requestAnimationFrame(() => requestAnimationFrame(() => setTimeout(send, 0)));
};

export const wrapRootElement = ({ element }) => (
  <>
    <CookieConsent />
    {element}
  </>
);
